export default "__VITE_PUBLIC_ASSET__eb36ecdf__"